/**
 * @description: This is copied from the auto generated types, but we have a bug with the auto generated types
 *     when they are "magically" imported globally. If you need to use them in our code, you must import directly.
 */
export var DealSagaStep;
(function (DealSagaStep) {
    DealSagaStep["Started"] = "STARTED";
    DealSagaStep["Order"] = "ORDER";
    DealSagaStep["Update"] = "UPDATE";
    DealSagaStep["Pay"] = "PAY";
    DealSagaStep["Complete"] = "COMPLETE";
    DealSagaStep["Error"] = "ERROR";
})(DealSagaStep || (DealSagaStep = {}));
